export interface NotificationSetting {
  id: string;
  code: string;
  name: string;
  groups: Group[];
  isOwnerOnly: boolean;
}

export interface GroupSetting {
  id: string;
  name: string;
  description: string;
}

export interface Group {
  id: string;
  name: string;
  description: string;
  subGroups: Group[];
}

export interface NotificationSettingContent {
  content: NotificationSetting[];
}

export interface NotificationSettingUpdate {
  name: string;
  groupIds: string[];
  isOwnerOnly: boolean;
}

export const notSupportingOwnerOnlySettingList = [
  "DATA_CONFIGURATION_UPDATE",
  "EXPORT",
  "NEW_PERMISSION",
  "POST/LINK"
]